import { memo } from 'react';
import EvaluationTables from './EvaluationTables';
import PlottingInterface from './PlottingInterface';

interface TrainingResultsProps {
    uploadSessionId: string;
    sessionName?: string;
}

const TrainingResults = memo(({
    uploadSessionId,
    sessionName
}: TrainingResultsProps) => {
    return (
        <div className="space-y-8 mt-8">
            {/* Evaluation Tables - Show ONLY after MODEL TRAINING completion */}
            <EvaluationTables
                sessionId={uploadSessionId}
                sessionName={sessionName}
            />

            {/* Plotting Interface - Show ONLY after MODEL TRAINING completion */}
            <div className="mt-8">
                <PlottingInterface
                    sessionId={uploadSessionId}
                    inputVariables={[]} // Will be fetched from API
                    outputVariables={[]} // Will be fetched from API
                />
            </div>
        </div>
    );
});

TrainingResults.displayName = 'TrainingResults';

export default TrainingResults;
